export default {
  'result': {
    'code': 0,
    'msg': 'SUCCESS'
  },
  'contents': [{
    'id': 576,
    'title': '外交部回应日本网友给武汉加油：艰难时刻给予支持我们铭记在心',
    'desc': '中国外交部发言人华春莹今天表示，此次疫情发生以来，无论日本政府还是社会各界，都给予了中国很多理解和支持。我想很多中国网民和我一样，都注意到了日本人民温暖人心的举动。在当前抗击疫情的艰难时刻，我们表示衷心感谢，铭记在心。病毒无情人有情，疫情是一时的，友情是长久的。',
    'jumpLink': {
      'type': 0,
      'url': '',
      'appId': '',
      'appVer': 'release'
    },
    'from': '信息来源：央视新闻',
    'publicTime': '2020-02-04 16:02',
    'timeShaftDesc': '2020-02-04 16:02',
    'imgUrl': '',
    'tags': []
  }, {
    'id': 575,
    'title': '湖北武汉防护用品供需矛盾突出',
    'desc': '国家卫健委医政医管局副局长焦雅辉：①最短缺的还是医用防护服和N95口罩；②现派出支援湖北的医疗队时，要求他们尽量戴上一些防护用品，以缓解湖北和武汉防护用品供应紧张的情况；③恢复生产、提高产能、多方捐赠、海外进口，有关部门正在通过多渠道积极解决。',
    'jumpLink': {
      'type': 0,
      'url': '',
      'appId': '',
      'appVer': 'release'
    },
    'from': '信息来源：央视新闻',
    'publicTime': '2020-02-04 15:55',
    'timeShaftDesc': '2020-02-04 15:55',
    'imgUrl': '',
    'tags': []
  }, {
    'id': 574,
    'title': '全国出院患者平均住院9天多，湖北省平均20天',
    'desc': '国家卫健委医政医管局副局长焦雅辉：目前对于治愈率的计算还没有明确的公式，但现在除了湖北以外，全国住院患者住院的最短时间是海南省5天，最长的是广东省12.75天。除湖北以外全国出院患者的平均住院日是9天多一点，湖北省平均住院日是20天。从平均住院日来讲，很多患者住院后不用很久就能很快出院，治疗效果还是不错的。',
    'jumpLink': {
      'type': 0,
      'url': '',
      'appId': '',
      'appVer': 'release'
    },
    'from': '信息来源：央视新闻',
    'publicTime': '2020-02-04 15:46',
    'timeShaftDesc': '2020-02-04 15:46',
    'imgUrl': '',
    'tags': []
  }, {
    'id': 573,
    'title': '湖北省和武汉市的确诊病例病死率高于全国水平',
    'desc': '截至昨晚24时，全国累计确诊病例数20438人，累计死亡425人。死亡患者主要集中在湖北省，累计414人，占全国97%，湖北省确诊病例病死率3.1%；武汉市的死亡人数是313人，占全国死亡的74%，#武汉确诊病例病死率4.9%。',
    'jumpLink': {
      'type': 0,
      'url': '',
      'appId': '',
      'appVer': 'release'
    },
    'from': '信息来源：央视新闻',
    'publicTime': '2020-02-04 15:34',
    'timeShaftDesc': '2020-02-04 15:34',
    'imgUrl': '',
    'tags': []
  }, {
    'id': 572,
    'title': '湖北省红十字会3名领导被问责',
    'desc': '针对反映湖北省红十字会在捐赠款物接收分配中的有关问题，湖北省纪委监委开展调查核实工作。经调查，省红十字会有关领导和干部在疫情防控期间接收和分配捐赠款物工作中存在不担当不作为、违反“三重一大”规定、信息公开错误等失职失责问题，经湖北省纪委监委研究并报省委批准，决定免去张钦省红十字会党组成员、专职副会长职务，并给予其党内严重警告、政务记大过处分；给予省红十字会党组成员陈波党内严重警告、政务记大过处分；给予省红十字会党组书记、常务副会长高勤党内警告处分。省红十字会其他责任人员按照干部管理权限由有关党组织依纪依规处理。',
    'jumpLink': {
      'type': 0,
      'url': '',
      'appId': '',
      'appVer': 'release'
    },
    'from': '消息来源：央视新闻',
    'publicTime': '2020-02-04 14:46',
    'timeShaftDesc': '2020-02-04 14:46',
    'imgUrl': '',
    'tags': []
  }, {
    'id': 571,
    'title': '上海通报7个月大女婴病例情况',
    'desc': '今天，上海市卫健委公布一名7月龄新型冠状病毒感染的肺炎病例情况：2月3日经诊断，女婴及其母亲、外公为确诊病例；其父亲、奶奶、外婆新型冠状病毒核酸检测阴性。目前，女婴及其母亲、外公都在定点医院接受治疗，病情平稳。详细情况如下：\n\n该女婴的外公、外婆于1月20日从武汉来沪，21日和24日家庭聚餐，25日社区卫生服务中心接到2人主动健康申报后即进行核实，26日将2人纳入重点地区来沪人员进行管理。当时，女婴与外公、外婆和父母住在一起。\n\n2月2日，女婴爷爷被诊断为新型冠状病毒感染的肺炎，女婴及其父亲、母亲、奶奶、外公、外婆等作为密切接触者进行居家医学观察，当天下午多人出现发热症状，立即转至医院隔离治疗。2月3日经诊断，女婴及其母亲、外公为确诊病例；其父亲、奶奶、外婆新型冠状病毒核酸检测阴性，继续落实隔离观察。\n\n目前，女婴及其母亲、外公都在定点医院接受治疗，病情平稳。',
    'jumpLink': {
      'type': 0,
      'url': '',
      'appId': '',
      'appVer': 'release'
    },
    'from': '消息来源：央视新闻',
    'publicTime': '2020-02-04 14:38',
    'timeShaftDesc': '2020-02-04 14:38',
    'imgUrl': '',
    'tags': []
  }, {
    'id': 570,
    'title': '紧急扩散！呼和浩特一出租车司机确诊 寻找乘蒙AY1754出租车乘客',
    'desc': '患者万某某，女 ，系出租车（蒙AY1754）驾驶员，目前已被确诊为新型冠状病毒感染肺炎病例。1月18日-30日，该患者除27日、29日在家休息，其余时间都在运营出租车。该出租车运营期间，现已梳理出利用微信支付138人、支付宝支付4人，共 142人，其余人员使用现金支付。凡在上述时间段内乘坐蒙AY1754出租车的乘客，务必向当地疾控中心登记，并在家进行居家隔离。期间如有发热、咳嗽、乏力等症状，请及时联系网格管理员或当地疾控中心，规范就诊。',
    'jumpLink': {
      'type': 0,
      'url': '',
      'appId': '',
      'appVer': 'release'
    },
    'from': '消息来源：央视新闻',
    'publicTime': '2020-02-04 14:08',
    'timeShaftDesc': '2020-02-04 14:08',
    'imgUrl': '',
    'tags': []
  }, {
    'id': 569,
    'title': '海南海口5人因疫情防控失职失责被通报',
    'desc': '昨天，海南省海口市纪委监委通报了龙华区城西镇党委书记林梦云等5人在疫情防控工作中失职失责的典型问题。据了解，1月20日，1名湖北武汉籍男子自武汉抵琼后入住海口市龙华区城西镇金沙社区某小区，但城西镇人民政府及金沙社区居委会均未组织人员上门核实情况。31日，该男子经检测诊断患新型冠状病毒肺炎，该男子的妻子、大女儿也出现疑似症状。其间，该男子两次外出超市、农贸市场购物，造成重大疫情隐患。对此，海口市龙华区纪委决定，对金沙社区党支部书记、居委会主任张武金予以立案审查，给予撤销党内职务处分；给予城西镇党委书记林梦云、镇长陈运杰责令书面检查，城西镇规划所所长、金沙社区挂点领导张才斌诫勉问责；对网格员颜丽娟给予通报批评。',
    'jumpLink': {
      'type': 0,
      'url': '',
      'appId': '',
      'appVer': 'release'
    },
    'from': '消息来源：央视新闻',
    'publicTime': '2020-02-04 13:36',
    'timeShaftDesc': '2020-02-04 13:36',
    'imgUrl': '',
    'tags': []
  }, {
    'id': 568,
    'title': '四川白马镇副镇长因违规聚会被免职后确诊',
    'desc': '昨天，四川内江市纪委监委曝光3起涉及防疫工作违纪违规典型问题，其中一起：1月25日晚、26日晚，白马镇副镇长郑常清违反有关规定，参与群体性聚集和娱乐等活动。2月2日，郑常清被免去副镇长职务，被监察立案调查。3日，郑常清出现临床症状，导致包括白马镇在内的干部群众31人被集中医学观察，18人居家观察。',
    'jumpLink': {
      'type': 0,
      'url': '',
      'appId': '',
      'appVer': 'release'
    },
    'from': '消息来源：央视新闻',
    'publicTime': '2020-02-04 12:16',
    'timeShaftDesc': '2020-02-04 12:16',
    'imgUrl': '',
    'tags': []
  }, {
    'id': 566,
    'title': '内蒙古回应确诊病例与楼上有接触史',
    'desc': '昨天，内蒙古鄂尔多斯市达拉特旗就“内蒙古达拉特旗新增病例无外出、无接触史，住在确诊病例楼上”等话题进行情况通报：经达拉特旗疾控部门对第4例确诊病例白某云组织流行病学调查发现，白某云在树林召东源新村居住，系首例确诊病例宋某楼上住户。期间，白某云一家曾多次上下楼经过三楼宋某家，宋某家门经常敞开、门口常有生活垃圾堆放。\n经达拉特旗疾控部门对第7例确诊病例王某组织流行病学调查发现，王某与达拉特旗首例确诊病例宋某一家有接触史，与白某云及妻子张某芳也有长时间的密切接触史。流行病学调查具体情况是，1月22日晚21时，王某从东胜拼车回到达旗东源新村家中后，随母亲白某转到白某云家，当时王某未佩戴口罩，白某转戴有口罩。上楼过程中经过三楼302室宋某家门口时，其房门敞开，两位男士（其中一人为宋某）均未佩戴口罩站在门口与屋内人员说话，经过时距离较近。当晚约21时30分张某某（系白某云妻子，第6确诊病例）上楼回到家中；约22时白某云上楼回到家中，23时许王某与母亲白某转离开白某云家。1月23日—1月27日期间，王某与白某云、张某某多次乘坐车辆往返于东源新村与耳字壕河洛图白家梁，1月24日3人在东源新村5号楼阳面16号车库一起过春节，有长时间的密切接触。根据上述情况，不排除宋某是白某云、张某某、王某感染新型冠状病毒感染的肺炎的源头，有关专家仍在进一步调查核实中。',
    'jumpLink': {
      'type': 0,
      'url': '',
      'appId': '',
      'appVer': 'release'
    },
    'from': '消息来源：央视新闻',
    'publicTime': '2020-02-04 11:34',
    'timeShaftDesc': '2020-02-04 11:34',
    'imgUrl': '',
    'tags': []
  }],
  'totalCnt': 532,
  'code': 0,
  'message': '',
  'uiMessage': ''
}
